import { Link, Stack, Tooltip } from '@mui/material';
import { Link as ReactRouterLink } from 'react-router-dom';

import { Span, Text } from 'common';

import { FlowDefinitionStateTag } from '../../scenes/Agents/Flows/Definitions/common/StateTag';
import { useFlowRunByIdBasic } from '../../scenes/Agents/Flows/Runs/apis/flowRun';

enum FlowRunLinkVariant {
  NameAndVersion = 'NameAndVersion',
  NameVersionAndState = 'NameVersionAndState',
}

interface FlowRunLinkProps {
  flowRunId: string;
  // variant default is NameAndVersion
  variant?: FlowRunLinkVariant;
}

export function FlowRunLink(props: FlowRunLinkProps) {
  const { flowRunId, variant } = props;

  const { data, isSuccess } = useFlowRunByIdBasic(flowRunId);

  return (
    <Link
      component={ReactRouterLink}
      onClick={(event) => event.stopPropagation()}
      to={`/agents/flowRuns/${flowRunId}`}
    >
      {!isSuccess && flowRunId}
      {isSuccess && (
        <Tooltip
          title={
            <Stack gap={1}>
              <Text variant="body2" color="inherit">
                <b>Name: </b>
                {data.flow.name}
              </Text>
              <Text variant="body2" color="inherit">
                <b>Version: </b>
                {data.flowDefinition.version}
              </Text>
            </Stack>
          }
          placement="left"
          arrow
        >
          <Span sx={{ alignItems: 'center', gap: 1, textDecoration: 'inherit' }}>
            <span>{`${data.flow.name} (v${data.flowDefinition.version})`}</span>
            {variant === FlowRunLinkVariant.NameVersionAndState && (
              <FlowDefinitionStateTag state={data.flowDefinition.state} />
            )}
          </Span>
        </Tooltip>
      )}
    </Link>
  );
}
